import React from 'react';
import PropTypes from 'prop-types';
import BackgroundGeolocation from 'cordova-background-geolocation';
import pick from 'lodash/fp/pick';
import isEqual from 'lodash/isEqual';
import { isPlatform } from '@ionic/core';
import map from 'lodash/map';
import { geolocationConfig, GEO_DEBUG } from './util'; // need better path

const GEOFENCE_COMPARE_PROPERTIES = [
  'identifier',
  'latitude',
  'longitude',
  'radius',
  'loiteringDelay',
];

function areEqualGeofenceCollections(geofencesA, geofencesB) {
  return isEqual(
    map(geofencesA, pick(GEOFENCE_COMPARE_PROPERTIES)),
    map(geofencesB, pick(GEOFENCE_COMPARE_PROPERTIES)),
  );
}

function withGeolocation(BaseComponent) {
  if (!(isPlatform('android') || isPlatform('ios'))) {
    return BaseComponent;
  } else {
    // Breaks if run on web
    return class Geolocation extends React.Component {
      static propTypes = {
        geofences: PropTypes.arrayOf(
          PropTypes.shape({
            identifier: PropTypes.string,
            extras: PropTypes.object,
            radius: PropTypes.number,
            notifyOnDwell: PropTypes.bool,
            notifyOnEntry: PropTypes.bool,
            notifyOnExit: PropTypes.bool,
            latitude: PropTypes.number,
            loiteringDelay: PropTypes.number,
            longitude: PropTypes.number,
          }),
        ).isRequired,
      };

      componentDidMount() {
        GEO_DEBUG && console.log('*DTA Geolocation.componentDidMount()');
        this.start();
        this.updateGeofences();
      }

      componentDidUpdate() {
        GEO_DEBUG && console.log('*DTA Geolocation.componentDidUpdate()');
        this.updateGeofences();
      }

      start = () => {
        GEO_DEBUG && console.log('*DTA Geolocation.start()');
        BackgroundGeolocation.ready(geolocationConfig, state => {
          if (!state.enabled) {
            BackgroundGeolocation.start();
          }
        });
      };

      updateGeofences = () => {
        GEO_DEBUG && console.log('*DTA Geolocation.updateGeofences()');
        BackgroundGeolocation.getGeofences().then(currentGeofences => {
          if (
            !areEqualGeofenceCollections(currentGeofences, this.props.geofences)
          ) {
            this.refreshGeofences();
          }
        });
      };

      refreshGeofences = () => {
        GEO_DEBUG &&
          console.log(
            '*DTA Geolocation.refreshGeofences()',
            this.props.geofences,
          );
        BackgroundGeolocation.removeGeofences().then(() => {
          BackgroundGeolocation.addGeofences(this.props.geofences);
        });
      };

      render() {
        return <BaseComponent {...this.props} />;
      }
    };
  }
}

export default withGeolocation;



// WEBPACK FOOTER //
// ./src/modules/Geolocation/withGeolocation.js